import { Component, forwardRef, inject, Input } from '@angular/core'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { AsyncPipe } from '@angular/common'
import { ClientService } from '../../../../../../services/domain/client/client.service'
import { Client } from 'src/app/models/client'
import { MultiSelectModule } from 'primeng/multiselect'
import { FloatLabelModule } from 'primeng/floatlabel'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
  selector: 'app-multiple-client-select',
  templateUrl: './multiple-client-select.component.html',
  styleUrls: ['./multiple-client-select.component.scss'],
  standalone: true,
  imports: [IonicModule, MultiSelectModule, AsyncPipe, FormsModule, FloatLabelModule, TranslocoModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultipleClientSelectComponent),
      multi: true,
    },
  ],
})
export class MultipleClientSelectComponent implements ControlValueAccessor {
  @Input() excludeClientId: number

  private _value: number[] = []
  protected selectedItem: Client[] = []
  private _onChange: (value: number[]) => void
  protected _onTouched: () => void = () => {}
  private clientsService = inject(ClientService)

  protected readonly clients$: Observable<Client[]> = this.clientsService.getActiveWithCaching().pipe(
    map(clients =>
      clients
        .filter(c => c.id !== this.excludeClientId)
    ),
    tap((clients) => {
      this.selectedItem = clients.filter((c) => this._value.includes(c.id))
    }),
  )

  registerOnChange(fn: any): void {
    this._onChange = fn
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn
  }
  writeValue(value: number[] | number | null): void {
    if (Array.isArray(value)) {
      this._value = value
    } else if (typeof value === 'number' && !isNaN(value)) {
      this._value = [value]
    } else {
      this._value = []
    }
  }
  protected onSelectedChange(value: Client[]) {
    this._value = value.map((c) => c.id)
    this._onChange?.(this._value)
  }
}
